import { useChannelTalk } from '@repo/channel-talk';
import { sharePage } from '@repo/common-utils';
import { useUserEventLogger } from '@repo/tracking-service';
import { Button, useToast } from '@zenterprise-inc/ui';
import { useRouter } from 'next/router';

import s from './Layout.module.scss';

import { isInviteEventProceeding } from '@/lib/constants/event';
import { INVITE_PROMOTION_PATH, SUPPORT_BOT_LINK } from '@/lib/constants/link';
import { COMMON_PATHS } from '@/lib/constants/paths';

const HomeHeader = () => {
  const router = useRouter();
  const toast = useToast();
  const { sendClickEvent } = useUserEventLogger();
  const { showMessenger, openChannelTalk } = useChannelTalk();
  const isPersonalTritx = sessionStorage.getItem('isPersonalTritx') === 'true';

  const goHome = () => {
    sendClickEvent('landing_topnav_logo');
    const targetPath = isPersonalTritx ? COMMON_PATHS.양도세환급랜딩 : router.pathname === '/home/landing' ? '/home/landing' : '/';

    router.push(targetPath, undefined, { scroll: true });
  };

  const handleAsk = () => {
    sendClickEvent('landing_topnav_cx');

    if (isPersonalTritx) {
      openChannelTalk(SUPPORT_BOT_LINK.양도세환급랜딩);
    } else {
      showMessenger();
    }
  };

  const goInvite = () => {
    sendClickEvent('landing_topnav_invite');

    router.push(INVITE_PROMOTION_PATH);
  };

  const clickShared = () => {
    sendClickEvent('landing_topnav_share');

    if (isPersonalTritx) {
      sharePage(
        {
          title: '양도세 환급금 무료 진단',
          text: '1인 평균 150만원 환급, 30초 만에 무료로 진단해드려요! 기본공제 누락부터 특례 적용 여부까지 확인해보세요.',
          url: `${window.location.origin}${COMMON_PATHS.양도세환급랜딩}`
        },
        () => {
          toast({ content: '링크를 복사했습니다.', icon: 'check-mark', iconColor: 'green.600' });
        }
      );
    } else {
      sharePage(
        {
          title: '개인/법인사업자 환급금 무료 조회 - 비즈넵 세금 환급',
          url: 'https://ab.bznav.com/g9htxq'
        },
        () => {
          toast({ content: '링크를 복사했습니다.', icon: 'check-mark', iconColor: 'green.600' });
        }
      );
    }
  };

  return (
    <header className={'page-padding shadow-[0_1px_0_rgba(0,0,0,0.1)]'}>
      <div className={'mx-auto flex w-full container-xlarge  h-[52px] items-center justify-between pl-1'}>
        <img
          src={'/images/symbols/bznav-refund-logo.svg'}
          width={113}
          height={24}
          className={'hover:cursor-pointer pointer-events-auto'}
          alt={'bznav-refund-logo'}
          onClick={goHome}
        />
        <div className={'relative flex gap-4 sm:gap-6'}>
          <Button.Text size={'small'} state={'gray'} className={`${s.animate_underline} relative`} onClick={handleAsk}>
            문의하기
          </Button.Text>
          <Button.Text
            size={'small'}
            state={'gray'}
            className={`${s.animate_underline} relative !inline-block`}
            onClick={isInviteEventProceeding && !isPersonalTritx ? goInvite : clickShared}
          >
            {isInviteEventProceeding && !isPersonalTritx ? '친구 초대하기' : '공유하기'}
          </Button.Text>
        </div>
      </div>
    </header>
  );
};

export default HomeHeader;
